import React, { useEffect, useState } from "react";
import Icons from "../../assets/icons/index";
import { Formik, useFormik } from "formik";
import TextFieldInput from "../../components/common/input/TextField";
import Button from "../../components/common/button/Button";
import * as Yup from "yup";
import TextInput from "../../components/common/input/TextInput";
import { useNavigate } from "react-router-dom";
import callApi from "../../services/api/apiClient";
import useAuth from "../../helper/hooks/lang/useAuth";
import { set } from "lodash";

const loginSchema = Yup.object().shape({
  email: Yup.string().required("Email is required"),
  password: Yup.string()
    .min(3, "Password must be at least 3 characters long")
    .required("Password is required"),
});

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [loginStatus, setloginStatus] = useState(null);

  const token = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token]);

  console.log("Token...", token);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    validationSchema: loginSchema,
    onSubmit: (values, actions) => {
      setIsLoading(true);
      setloginStatus(null);
      callApi("auth/login")
        .withHeaders({
          login: encodeURIComponent(values.email),
          password: encodeURIComponent(values.password),
        })
        .loadingGroup("loginPage")
        .withJSFetch()
        .execute()
        .then((res) => {
          if (res?.error || res?.status == "fail") {
            setloginStatus(res?.error);
          } else {
            console.log("Login success", res);
          }
        })
        .catch((error) => {
          setloginStatus("Email or password is incorrect", error);
        });

      setIsLoading(false);
      actions.setSubmitting(false);
      actions.resetForm();
      // navigate("/");
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    formik.setFieldValue(name, value);
    setloginStatus(null); // Clear login status when user starts typing
  };

  return (
    <div className="flex items-center justify-center h-screen bg-white-1">
      <div className="bg-white-0 p-[60px] rounded-[12px]">
        <div className="grid sm:grid-cols-4 gap-4">
          <div className="col-start-2 col-span-2">
            <img src={Icons.marigoldLogo} alt="" className="w-52 h-32" />
          </div>
        </div>
        <p className="text-blue-1 text-xl font-interSemiBold">
          Hello, let’s get started!
        </p>
        <p className="text-black-0 text-lg font-interRegular">
          Login to continue.
        </p>

        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-[32px]">
            <TextInput
              name={"email"}
              type="text" // email
              label={"Email"}
              placeholder={"Enter email"}
              className={"w-full outline-none"}
              onChange={handleChange}
              value={formik.values.email}
              required
            />
            {formik?.touched.email && formik?.errors.email ? (
              <span className=" text-sm text-red-2">{formik.errors.email}</span>
            ) : null}
          </div>
          <div className="mt-[24px]">
            <TextInput
              name={"password"}
              type="password"
              label={"Password"}
              placeholder={"Enter password"}
              className={"w-full"}
              onChange={handleChange}
              value={formik.values.password}
              required
            />
            {formik?.touched.password && formik?.errors.password ? (
              <span className=" text-sm text-red-2">
                {formik.errors.password}
              </span>
            ) : null}
          </div>
          {loginStatus && (
            <div className="mt-4 text-sm text-semibold text-red-500">
              {loginStatus}
            </div>
          )}
          <p className="text-black-3 text-base font-interRegular mt-[12px]">
            Don’t have an account?
            <span className="text-green-0 ml-[4px] text-base font-interRegular cursor-pointer">
              Create
            </span>
          </p>
          <Button
            type={"submit"}
            className="bg-blue-1 text-white-0 text-base h-[48px] w-full  p-[8px] 2xl:p-[12px] rounded-[8px] flex items-center justify-center mt-[20px] lg:mt-[30px]  font-interSemiBold"
            disabled={formik.isSubmitting || isLoading}
          >
            Login
          </Button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
